export function useIsWhiteLabelDomain() {
  const { hostname } = document.location;

  const isWhiteLabelDomain =
    !hostname.includes("numerous") && !hostname.includes("localhost");

  return { isWhiteLabelDomain };
}
